import QAChatWrapper from "@features/session/components/QASearch/QAChatWrapper";
import { isWeb } from "@helpers/platform";
import useClerkUser from "@hooks/useClerkUser";

import { useDevice } from "@hooks/useDevice";

import Box from "@memorang/ui/src/components/Box";
import ModalHeader from "components/ModalHeader";
import { Redirect, Stack, usePathname } from "expo-router";

export default function Layout() {
	const { isSignedIn, isLoaded } = useClerkUser();

	const pathname = usePathname();
	const { isIpad } = useDevice();

	if (isLoaded && !isSignedIn && pathname !== "/redeem") {
		return <Redirect href={"/(auth)/login"} />;
	}

	const modalVariant = isIpad
		? ("containedModal" as const)
		: ("modal" as const);

	return (
		<Box flex={1} flexDirection="row" justifyContent="space-between">
			<Stack
				screenOptions={{
					headerShown: false,
					contentStyle: {
						flex: 1,
					},
				}}
			>
				<Stack.Screen
					name="purchase/index"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => <ModalHeader headerTitle="Purchase" />,
					}}
				/>
				<Stack.Screen
					name="session/customize"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle="Custom study session"
							/>
						),
					}}
				/>
				<Stack.Screen
					name="suggestcorrection"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="info"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="profile/change-avatar"
					options={{
						presentation: modalVariant,
						headerShown: true,
						header: () => (
							<ModalHeader
								backIcon="arrow-left"
								headerTitle="Choose your avatar"
							/>
						),
					}}
				/>
				<Stack.Screen
					name="feedback"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="exams"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
				<Stack.Screen
					name="aila/[itemId]"
					options={{
						presentation: modalVariant,
						headerShown: false,
					}}
				/>
			</Stack>
			{isWeb && <QAChatWrapper />}
		</Box>
	);
}
